import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { IonContent, LoadingController } from '@ionic/angular';
import { fromEvent } from 'rxjs';
import { first } from 'rxjs/operators';
import { Navigator } from 'src/app/services/routing/navigator';
import { CustomerModel } from 'src/app/models/customer-model';
import { isUndefined } from 'src/app/services/codeUtils';
import { ConfigService } from 'src/app/services/config/config.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { CashierBase } from '../../cashier-base/cashier-base';
import { RoutingService } from 'src/app/services/routing/routing.service';

@Component({
  selector: 'app-deposit-playplus-action',
  templateUrl: './deposit-playplus-action.component.html',
  styleUrls: ['./deposit-playplus.component.scss'],
})

export class DepositPlayplusActionComponent extends CashierBase implements OnInit {
  @ViewChild(IonContent, { static: false }) content: IonContent;
  @ViewChild('iFrameId') iframe: ElementRef;
  @Input() action: any;

  public iframe_url: any;
  public loading: any;
  public loadingDuration: number;

  constructor(
    public config: ConfigService,
    public loadingController: LoadingController,
    public navigator: Navigator,
    public userSessionService: UserSessionService,
    private routing: RoutingService,
  ) {
    super();

    const obs = fromEvent(window, 'message');
    const observer = obs.subscribe((event: any) => {
      const eventData = event.data.id;
      if (eventData == 'playplus_return') {
        this.redirectActions();
        observer.unsubscribe();
      }
    });

    this.loadingDuration = this.config.getConfig().FEATURE_PLAYPLUS_LOADING_DURATION ?? 10000;
  }

  ngOnInit(): void {

    const return_url = this.getReturnUrl();

    this.userSessionService.getCustomer().pipe(first()).subscribe((customer: CustomerModel) => {
      if (!isUndefined(customer) && !!customer) {
        let params = {
          'customer_id': customer.customerId,
          'session_token': this.userSessionService.getSessionToken(),
          'MemberNumber': `${this.config.getConfig().FEATURE_SIGHTLINE_PREPEND_STATE}${customer.customerId}`, // append State code as Siteline requires it differentiate between our player accounts
          'FirstName': this.rfc3986EncodeURIComponent(customer.firstName),
          'LastName': this.rfc3986EncodeURIComponent(customer.lastName),
          'PhoneNumber': encodeURIComponent(customer.address.phoneNumber),
          'Email': encodeURIComponent(customer.email),
          'Address': this.rfc3986EncodeURIComponent(customer.address.street),
          'City': encodeURIComponent(customer.address.city),
          'State': encodeURIComponent(customer.address.state),
          'PostalCode': encodeURIComponent(customer.address.postalCode),
          'ReturnURL': encodeURIComponent(return_url)
        };

        let queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');
        this.iframe_url = `${this.config.getEnv().webservices_url}/external/prepaid-post?${queryString}`;
      }
    }, error => console.error("Play Plus Action Customer Error", error));
  }

  ionViewWillEnter() {
    this.showLoading();
  }

  ngAfterViewInit(): void {
    const iFrameElement = this.iframe.nativeElement as HTMLIFrameElement;
    iFrameElement.onload = () => {
      this.loading.dismiss();
    };
  }

  private redirectActions(): any {
    this.showLoading();
    setTimeout(() => {
      this.loading.dismiss();
      return this.onBack()
    }, 1000)
  }

  private getReturnUrl(): string {
    const lobbyURL: any = this.config.getConfig().LOBBY_URL;
    const urlString: string = '/assets/static/playplus_script.html?';
    const url: string = lobbyURL + urlString;
    return url;
  }

  async showLoading() {
    this.loading = await this.loadingController.create({
      message: 'Please wait loading...',
      duration: this.loadingDuration
    });

    this.loading.present();
  }

  public rfc3986EncodeURIComponent(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, escape);
  }

  public onBack = () => {
    return this.navigator.navigateTo('DepositPlayplusComponent');
  }

  closeDialog() {
    this.routing.defaultRoute();
  }

}
